<template lang="pug">
  .folder-details.column.space-between
    router-link.folder-info.column.item-1.space-between(:to='`/folders/${folder.id}`')
      .column
        simple-svg.light-gray-icon(:filepath='folderIcon' :width='"60px"' :height='"60px"')
        .title-medium.word-break.m-top-2.m-bottom-1.black
          | {{ folder.name }}
      .column
        span.text-small.dark-gray.m4-bottom-1
          | {{ isCopy ? $t('folders.copiedOn', { date: creationDate }) : $t('folders.createdOn', { date: creationDate }) }}
        span.text-small.dark-gray
          | {{ $t('folders.by', { name: shared ? folder.ownerName : $t('folders.you') }) }}
    .folder-actions.row.space-between.middle
      button.icon-button.hover-blue(:title='$t("folders.shareModal.title")' type='button' @click='openShareFolderModal')
        simple-svg.blue-hover-dark-gray(:filepath='shareIcon' :width='"15px"' :height='"15px"')
      folder-actions(
        :editPermission='this.hasEditPermission'
        smallIcon
        :folderId='folder.id'
        :folderName='folder.name'
      )
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

import FolderActions from '@/components/Folders/FolderActions'

import shareIcon from '@/assets/ic_share.svg'
import folderIcon from '@/assets/ic_folder.svg'
import dotsIcon from '@/assets/ic_more_dots.svg'

import { dateFormat, folderOrigins, userPermissions } from '../../utils/constants'

export default {
  props: {
    folder: { type: Object, required: true },
    shared: { type: Boolean, default: false }
  },
  components: { FolderActions },
  data() {
    return {
      shareIcon,
      folderIcon,
      dotsIcon
    }
  },
  computed: {
    creationDate() {
      return moment(this.folder.createdAt).format(dateFormat)
    },
    hasEditPermission() {
      return this.folder.userPermission !== userPermissions.read
    },
    isCopy() {
      return this.folder.origin === folderOrigins.copiedFromKimpleFolder
    }
  },
  methods: {
    ...mapActions(['showElement']),
    openShareFolderModal() {
      this.showElement({
        element: 'folderShareModal',
        props: {
          id: this.folder.id,
          name: this.folder.name,
          hasEditPermission: this.hasEditPermission
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.folder-details {
  border: 1px solid $light-gray;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  width: 100%;

  &:hover {
    box-shadow: 0 8px 16px 0 $shadow-gray1;
  }
}

.folder-info {
  padding: 20px;
}

.folder-actions {
  border-top: 1px solid $light-gray;
  height: 60px;
  padding: 0 8px;
}
</style>
